import { createStandardAction, createAsyncAction } from 'typesafe-actions'
import {
  GetReportListReq,
  GetReportListResp,
  Filter,
  GetReportDetailReq,
  GetReportDetailResp,
} from './types'

export const getReportListAction = createAsyncAction(
  'admin/report/constructroad/GET_LIST_REQ',
  'admin/report/constructroad/GET_LIST_RESP',
  'admin/report/constructroad/GET_LIST_FAIL'
)<GetReportListReq, GetReportListResp, any>()

export const getReportDetailAction = createAsyncAction(
  'admin/report/constructroad/GET_DETAIL_REQ',
  'admin/report/constructroad/GET_DETAIL_RESP',
  'admin/report/constructroad/GET_DETAIL_FAIL'
)<GetReportDetailReq, GetReportDetailResp, any>()

export const updateFilter = createStandardAction(
  'admin/report/constructroad/UPDATE_FILTER_ACTION'
)<Filter, void>()

export const clearFilter = createStandardAction(
  'admin/report/constructroad/CLEAR_FILTER_ACTION'
)<void>()

export const sortingTask = createStandardAction(
  'admin/report/constructroad/SORTING'
)<{
  name: string
  sort?: string
}>()

export const exportReportListAction = createAsyncAction(
  'admin/report/constructroad/EXPORT_LIST_REQ',
  'admin/report/constructroad/EXPORT_LIST_RESP',
  'admin/report/constructroad/EXPORT_LIST_FAIL'
)<GetReportListReq, GetReportListResp, any>()
